globalThis.appCustomerSpace = globalThis.appCustomerSpace || {};
appCustomerSpace.Controllers = appCustomerSpace.Controllers || {};
appCustomerSpace.Controllers.Nps = appCustomerSpace.Controllers.Nps || {};

appCustomerSpace.Controllers.Nps.NpsSubmissionsController = (function(superClass)
{
    utils.extend(NpsSubmissionsController, superClass);

    function NpsSubmissionsController() {
        return NpsSubmissionsController.__super__.constructor.apply(this, arguments);
    }

    NpsSubmissionsController.prototype = {
        init: function()
        {
            $npsSubmissionForm = $(".panel.panel-body#nps-submission-form");
            var $npsSubmissionNoteButtons     = $npsSubmissionForm.find(".nps-submission-note"),
                $npsSubmissionQuestion = $npsSubmissionForm.find(".nps-submission-question");

            $npsSubmissionNoteButtons.on({
                click: function () {
                    var $this = $(this),
                        noteNeutralityType = $this.data("note-neutrality-type"),
                        note = $this.data("note"),
                        $npsSubmissionQuestionWithNeutralityType = $npsSubmissionForm.find(".nps-submission-question-" + noteNeutralityType);

                    $("#accounts_satisfaction_nps_submission_note").val(note);

                    $npsSubmissionNoteButtons.removeClass("active-nps");
                    $this.addClass("active-nps");
                    $npsSubmissionQuestion.addClass("display-none");
                    $npsSubmissionQuestionWithNeutralityType.removeClass("display-none");
                }
            });

            return NpsSubmissionsController.__super__.init.apply(this, arguments);
        }
    }

    return NpsSubmissionsController;
})(appCustomerSpace.Controllers.MainController);
